import type { Dispatch, ReactNode, RefObject, SetStateAction } from 'react';
import { createContext, useContext, useMemo, useRef, useState } from 'react';

import type {
  ChartRef,
  ExtendedSeriesOptionsType
} from '@/features/_shared/chart/types/highcharts';

interface ChartContextType {
  chartRef: RefObject<ChartRef | null>;
  chartSeries: ExtendedSeriesOptionsType[] | undefined;
  setChartSeries: Dispatch<SetStateAction<ExtendedSeriesOptionsType[] | undefined>>;
}

const ChartContext = createContext<ChartContextType | undefined>(undefined);

export const ChartProvider = ({ children }: { children: ReactNode }) => {
  const chartRef = useRef<ChartRef | null>(null);
  const [chartSeries, setChartSeries] = useState<ExtendedSeriesOptionsType[]>();

  const value = useMemo(
    () => ({
      chartRef,
      chartSeries,
      setChartSeries
    }),
    [chartSeries]
  );

  return <ChartContext value={value}>{children}</ChartContext>;
};

export const useChartContext = () => {
  const context = useContext(ChartContext);
  if (!context) throw new Error('useChartContext must be used within ChartProvider');
  return context;
};
